import { Edit, SimpleForm, TextInput, SelectInput } from 'react-admin';
import { Box, Typography } from '@mui/material';

export const TutorEdit = () => (
  <Edit>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Personal Information</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="firstName" fullWidth />
        <TextInput source="lastName" fullWidth />
        <TextInput source="idNumber" label="ID Number" fullWidth />
        <TextInput source="dateOfBirth" type="date" fullWidth />
        <TextInput source="email" type="email" fullWidth />
        <TextInput source="phone" fullWidth />
        <TextInput source="address" fullWidth />
      </Box>
      <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>Tutor Details</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="specialisation" fullWidth />
        <TextInput source="yearsExperience" label="Years of Experience" type="number" fullWidth />
        <SelectInput
          source="status"
          choices={['Draft', 'Active', 'Inactive', 'Suspended'].map(s => ({ id: s, name: s }))}
          fullWidth
        />
      </Box>
    </SimpleForm>
  </Edit>
);
